import { render, staticRenderFns } from "./PausedAccountBanner.vue?vue&type=template&id=b1f79d6e&scoped=true&"
import script from "./PausedAccountBanner.vue?vue&type=script&lang=js&"
export * from "./PausedAccountBanner.vue?vue&type=script&lang=js&"
import style0 from "./PausedAccountBanner.vue?vue&type=style&index=0&id=b1f79d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f79d6e",
  null
  
)

export default component.exports